export enum OrganizationType {
  Developer = 'DEVELOPER',
  MarketingCompany = 'MARKETING_COMPANY'
}
